console.log('[sixpack] loaded');
(function () {

  const PACK_SIZE = 6;
  const SHOW_MISSING = new Set([1, 2]);
  let lastMissing = null;
  let lastTotal = null;
  const PRODUCTS_URL = '/collections/all/products.json?limit=4';

  function calcMissing(total) {
    const rest = total % PACK_SIZE;
    return (PACK_SIZE - rest) % PACK_SIZE;
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function getSuggestions() {
    const r = await fetch(PRODUCTS_URL, { credentials: 'same-origin' });
    const data = await r.json();

    return (data.products || []).map(p => {
      const v = (p.variants || []).find(x => x.available) || p.variants?.[0];
      if (!v) return null;

      return {
        title: p.title,
        image: p.images?.[0]?.src || '',
        price: v.price,
        variantId: v.id
      };
    }).filter(Boolean);
  }

  async function addVariant(id) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id, quantity: 1 })
    });
  }

  function formatMoney(value) {
    const n = Number(value);
    return n.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

/* ===== KONZERTTICKET-VERLOSUNG – DEAKTIVIERT 07/2026 =====
   Reaktivieren: diesen Block einkommentieren UND in update()
   den Aufruf `renderTicketSelect(mount, cart);` wieder einfügen
   (Markierung dort beachten).

const TICKET_MIN_TOTAL = 20000;
const TICKET_ATTRIBUTE = 'Welche Konzerttickets möchten Sie gewinnen?';

const TICKET_OPTIONS = [
  'Ich möchte an der Verlosung nicht teilnehmen',
  '24.07.2026: Roland Kaiser',
  '25.07.2026: Tream',
  '01.08.2026: David Garrett',
  '02.08.2026: Michael Patrick Kelly'
];

async function saveCartAttribute(value) {
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({
      attributes: {
        [TICKET_ATTRIBUTE]: value
      }
    })
  });
}

function renderTicketSelect(mount, cart) {
  injectTicketSelectStyles();

  const totalPrice = cart.total_price || 0;
  const existing = mount.querySelector('[data-ticket-select-field]');

  if (totalPrice < TICKET_MIN_TOTAL) {
    if (existing) existing.remove();
    return;
  }

  let field = existing;
  const currentValue = cart.attributes?.[TICKET_ATTRIBUTE] || TICKET_OPTIONS[0];

  if (!field) {
    field = document.createElement('div');
    field.className = 'upcart-upsells-title UpcartDesignSettings__cartTextColor styles_title__ cart-attribute__field ticket-select-field';
    field.setAttribute('data-ticket-select-field', '1');

    field.innerHTML =
      '<label for="welche-konzerttickets-mochtest-du-gewinnen">Welche Konzerttickets möchten Sie gewinnen?</label>' +
      '<select required class="required ticket-select" id="welche-konzerttickets-mochtest-du-gewinnen" name="attributes[Welche Konzerttickets möchten Sie gewinnen?]">' +
      TICKET_OPTIONS.map(function (option) {
        return '<option value="' + option + '">' + option + '</option>';
      }).join('') +
      '</select>';

    mount.prepend(field);

    const select = field.querySelector('select');

    select.addEventListener('change', async () => {
      await saveCartAttribute(select.value);
    });
  }

  const select = field.querySelector('select');
  select.value = currentValue;

  if (!cart.attributes?.[TICKET_ATTRIBUTE]) {
    saveCartAttribute(TICKET_OPTIONS[0]).catch(() => {});
  }
}

function injectTicketSelectStyles() {
  if (document.querySelector('[data-ticket-select-styles]')) return;

  const style = document.createElement('style');
  style.setAttribute('data-ticket-select-styles', '1');

  style.textContent =
    '#UpcartPopup .ticket-select-field {' +
    '  display: block;' +
    '  margin: 0 0 14px !important;' +
    '  padding: 0 !important;' +
    '  font-size: 14px !important;' +
    '  line-height: 1.3 !important;' +
    '  font-weight: 400 !important;' +
    '  background: transparent !important;' +
    '  border: 0 !important;' +
    '  padding-left: 23px !important;' +
    '  padding-right: 23px !important;' +
    '}' +
    '#UpcartPopup .ticket-select-field label {' +
    '  display: block !important;' +
    '  margin: 0 0 6px !important;' +
    '  font-size: 17px !important;' +
    '  line-height: 1.25 !important;' +
    '  font-weight: 700 !important;' +
    '  color: #000 !important;' +
    '  padding-top: 15px;' +
    '}' +
    '#UpcartPopup .ticket-select-field .ticket-select {' +
    '  display: block !important;' +
    '  width: 100% !important;' +
    '  height: 34px !important;' +
    '  min-height: 34px !important;' +
    '  padding: 5px 34px 5px 10px !important;' +
    '  border: 1px solid #d9d9d9 !important;' +
    '  border-radius: 0 !important;' +
    '  background-color: #fff !important;' +
    '  color: #111 !important;' +
    '  font-size: 14px !important;' +
    '  line-height: 1.2 !important;' +
    '  font-family: inherit !important;' +
    '  font-weight: 400 !important;' +
    '  box-shadow: none !important;' +
    '  outline: none !important;' +
    '  appearance: auto !important;' +
    '}';

  document.head.appendChild(style);
}

===== ENDE KONZERTTICKET-VERLOSUNG ===== */

function renderBox(mount, missing) {
  let box = mount.querySelector('[data-sixpack-box]');
  if (!box) {
    box = document.createElement('div');
    box.setAttribute('data-sixpack-box', '1');
    box.className = 'sixpack-box';
    mount.prepend(box);
  }

  const headline =
    missing === 1
      ? 'Noch 1 Flasche für ein volles 6er-Paket'
      : 'Noch 2 Flaschen für ein volles 6er-Paket';

  box.innerHTML = `
    <div class="sixpack-head">
      <div class="sixpack-head-left">
<div class="sixpack-ico" aria-hidden="true">
  ${window.sixpackIcon}
</div>

        <div>
          <div class="sixpack-title">${headline}</div>
        </div>
      </div>

      <button class="sixpack-toggle" type="button" aria-label="Details ein-/ausblenden">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.4 14.6 12 10l4.6 4.6 1.4-1.4L12 7.2 6 13.2z"/>
        </svg>
      </button>
    </div>

    <div class="sixpack-body">
      <ul class="sixpack-bullets">
        <li>
          <span class="sixpack-check" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
          </span>
          Ihre Bestellung wird als 6er-Paket verpackt – das ist stabiler und schützt die Flaschen besser.
        </li>
        <li>
          <span class="sixpack-check" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
          </span>
          Mit einer vollen Kiste wird der Versand effizienter und es gibt weniger Leerraum im Karton.
        </li>
      </ul>
    </div>
  `;

  const btn = box.querySelector('.sixpack-toggle');
  btn.addEventListener('click', () => {
    box.classList.toggle('is-collapsed');
  });
}

async function update() {
  const candidates = [
    '#UpcartPopup .upcart-cart-body',
    '#UpcartPopup .upcart-cart-body > div',
    '#UpcartPopup [class*="upcart-cart-body"]',
    '#UpcartPopup [class*="cartPreview_body"]',
    '[id="UpcartPopup"] [class*="cart-body"]'
  ];

  let mount = null;
  for (const sel of candidates) {
    mount = document.querySelector(sel);
    if (mount) break;
  }

  if (!mount) {
    console.log('[sixpack] mount not found yet');
    return;
  }

  const cart = await getCart();

  // TICKET-VERLOSUNG: bei Reaktivierung hier wieder einfügen:
  // renderTicketSelect(mount, cart);

  const total = (cart.items || []).reduce((sum, it) => sum + (it.quantity || 0), 0);
  const missing = calcMissing(total);

  if (total === lastTotal && missing === lastMissing) {
    return;
  }

  lastTotal = total;
  lastMissing = missing;

  console.log('[sixpack] total:', total, 'missing:', missing);

  const existing = mount.querySelector('[data-sixpack-box]');
  if (!SHOW_MISSING.has(missing)) {
    if (existing) existing.remove();
    return;
  }

  renderBox(mount, missing);
}

function startObserver() {
  const root = document.querySelector('#UpcartPopup') || document.body;

  const observer = new MutationObserver(() => {
    clearTimeout(window.__sixpackTimer);
    window.__sixpackTimer = setTimeout(() => update().catch(() => {}), 150);
  });

  observer.observe(root, { childList: true, subtree: true });
}

startObserver();
update().catch(() => {});

})();